module.exports = __webpack_public_path__ + "img/2100.60eab1bd.png";